<template>
  <div class="termo">
    <Termo :info="modal.hideButton" />
    <div class="buttons text-center">
      <div id="warn" v-if="!modal.hideButton">Leia até o final para liberar o botão de Aceite.</div>
      <div v-if="modal.hideButton" class="info text-center">Aceito em<br/>{{ modal.hideButton | date }}</div>
      <Button v-else id="btn_termo" :loader="load" layout="green-m" @click="accept_term" :disabled="true">ACEITAR TERMOS</Button>
    </div>
    <Status />
  </div>
</template>

<script>
import Termo from "@/statics/Termo.vue";
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";

export default {
  components: { Termo, Button, Status },
  props: { modal: Object },
  data() {
    return { load: false };
  },
  methods: {
    ...mapActions("user", ["ACCEPT_TERM"]),
    accept_term() {
      this.load = true;
      this.ACCEPT_TERM()
        .then((r) => {
          if (r.status === 200 || r.status === 201) {
            if (this.modal.callback) this.modal.callback();
            if (this.modal.cb) this.modal.cb();
            this.modal.show = false;
          }
          this.load = false;
        })
        .catch(() => (this.load = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.termo {
  color: $gray-6;
  padding: 10px 30px;
  max-width: 900px;
  border-radius: 12px;
  background: $white;

  .buttons {
    padding: 20px;
  }

  .status {
    margin-left: -21%;
  }
  .info{
    color: $purple;
  }
  #warn {
    color: $red-1;
    font-size: 14px;
    margin-bottom: 12px;
  }
}
</style>